import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateCapexAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	classification?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _classification = isRef<any>(classification) ? classification : ref<any>((typeof classification === 'function') ? classification() : classification)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		classification: _classification,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof classification === 'function') { _classification.value = classification() }

			return new c.CreateCapexAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _classification.value)
		})
	}

	return {
		...result,
		authorizedCreateCapexAccountCommandV1: result.authorized,
		createCapexAccountCommandV1: result.command,
		completedCreateCapexAccountCommandV1: result.completed,
		errorCreateCapexAccountCommandV1: result.error,
		invokeCreateCapexAccountCommandV1: result.invoke,
		invokingCreateCapexAccountCommandV1: result.invoking,
		succeedCreateCapexAccountCommandV1: result.succeed,
		validationErrorsCreateCapexAccountCommandV1: result.validationErrors,
		onSucceedCreateCapexAccountCommandV1: result.onSucceed,
	}
}

export function useDeleteCapexAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteCapexAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteCapexAccountCommandV1: result.authorized,
		deleteCapexAccountCommandV1: result.command,
		completedDeleteCapexAccountCommandV1: result.completed,
		errorDeleteCapexAccountCommandV1: result.error,
		invokeDeleteCapexAccountCommandV1: result.invoke,
		invokingDeleteCapexAccountCommandV1: result.invoking,
		succeedDeleteCapexAccountCommandV1: result.succeed,
		validationErrorsDeleteCapexAccountCommandV1: result.validationErrors,
		onSucceedDeleteCapexAccountCommandV1: result.onSucceed,
	}
}

export function useUpdateCapexAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	classification?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _classification = isRef<any>(classification) ? classification : ref<any>((typeof classification === 'function') ? classification() : classification)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		classification: _classification,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof classification === 'function') { _classification.value = classification() }

			return new c.UpdateCapexAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _classification.value)
		})
	}

	return {
		...result,
		authorizedUpdateCapexAccountCommandV1: result.authorized,
		updateCapexAccountCommandV1: result.command,
		completedUpdateCapexAccountCommandV1: result.completed,
		errorUpdateCapexAccountCommandV1: result.error,
		invokeUpdateCapexAccountCommandV1: result.invoke,
		invokingUpdateCapexAccountCommandV1: result.invoking,
		succeedUpdateCapexAccountCommandV1: result.succeed,
		validationErrorsUpdateCapexAccountCommandV1: result.validationErrors,
		onSucceedUpdateCapexAccountCommandV1: result.onSucceed,
	}
}

